import { useCallback, useMemo } from 'react'
import Field from '../../FieldsEdit/Field'
import FieldsResource from '../../../resources/FieldsResource'
import { Form, setIn, createSetNestedValue, getIn } from '../../Formik/forms'
import ForEachNestedValue from '../../forms/ForEachNestedValue'
import { newRecord } from '../../../lib/DataModel'
import { useRefreshable } from 'hooks/useRefreshable'
import Suspenseful from '../../Suspenseful'
import { useParams } from 'react-router-dom'
import { PageSection } from 'components/UI/Structure/PageSection'
import SectionTitle from 'components/UI/SectionTitle'
import { useOrbit } from 'providers/OrbitProvider'
import { useCurrentUser } from 'lib/CurrentUserProvider'

function FieldsEdit({client, fieldsResource, refreshFieldsResource}) {
  const { store } = useOrbit()
  const fields = fieldsResource.get()
  const { getClientRole } = useCurrentUser()
  const hasPermitEditRole = !!getIn(getClientRole(client.id), 'attributes.permitEdit')
  const permitEdit = hasPermitEditRole

  const newField = useCallback(() => {
    return newRecord({
      type: 'field',
      attributes: {fieldType: 'custom_select', name: '', description: '', required: true, groupable: false, private: false},
      relationships: { client: client }
    })
  }, [client])

  const initialValues = useMemo(() => {
    let values = {}

    fields.forEach(field => {
      createSetNestedValue({store, values, setFieldValue: (path, value) => { values = setIn(values, path, value) } })('fields', field)
    })

    return values
  }, [fields, store])

  return (
    <PageSection>
      <SectionTitle title='Fields' />
      <Form
        resource={client}
        initialValues={initialValues}
        onSave={refreshFieldsResource}
        backwardsCompatibleMargins={true}
        withoutSubmitButton={!permitEdit}
      >
        <ForEachNestedValue
          path="fields"
          buttonText="Add field"
          newValue={newField}
          component={Field}
          permitEdit={permitEdit}
        />
      </Form>
    </PageSection>
  )
}

export default function FieldsEditWrapper({ clientId: clientIdFromProps = '' }) {
  const { remote } = useOrbit()
  const { clientId: clientIdFromParams } = useParams()
  const clientId = clientIdFromProps || clientIdFromParams
  const client = useMemo(() => ({type: 'client', id: clientId}), [clientId])
  const [fieldsResource, refreshFieldsResource] = useRefreshable(clientId => new FieldsResource(remote, {type: 'client', id: clientId}), [clientId])

  return (
    <Suspenseful
      component={FieldsEdit}
      client={client}
      fieldsResource={fieldsResource}
      refreshFieldsResource={refreshFieldsResource}
    />
  )
}
